import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useLang } from "../LangContext";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function News() {
    const { t, lang } = useLang();
    const [items, setItems] = useState([]);

    useEffect(() => {
        axios.get(`${API}/news?kind=news`).then((r) => setItems(r.data.slice(0, 3))).catch(() => {});
    }, []);

    // Multilingual field picker with EN fallback (tolerates legacy plain strings)
    const pick = (f) => (f && typeof f === "object" ? (f[lang.toLowerCase()] || f.en || "") : f || "");

    if (!items.length) return null;

    return (
        <section id="news" data-testid="news-section" className="py-24 md:py-32 px-6 md:px-12 bg-inksurface">
            <div className="max-w-7xl mx-auto">
                <div className="mb-16 max-w-3xl">
                    <span className="text-xs font-mono uppercase tracking-[0.3em] text-volt">— {t.news.label}</span>
                    <h2 className="font-graffiti text-4xl md:text-6xl tracking-tight mt-6 text-white leading-[0.95]">
                        {t.news.title}
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
                    {items.map((n, i) => (
                        <Link
                            key={n.id}
                            to={`/news/${n.slug}`}
                            data-testid={`news-card-${i}`}
                            className="bg-ink group flex flex-col hover:bg-inksurface transition-colors"
                        >
                            <div className="aspect-[16/10] w-full overflow-hidden bg-zinc-900">
                                {n.image_url ? (
                                    <img
                                        src={n.image_url}
                                        alt={pick(n.title)}
                                        className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                                    />
                                ) : null}
                            </div>
                            <div className="p-6 md:p-8 flex flex-col flex-1">
                                <div className="text-xs font-mono uppercase tracking-wider text-volt mb-3">
                                    {n.date}
                                </div>
                                <h3 className="font-graffiti text-2xl md:text-3xl text-white leading-tight tracking-tight">
                                    {pick(n.title)}
                                </h3>
                                <p className="mt-4 text-sm text-zinc-400 leading-relaxed flex-1">{pick(n.excerpt)}</p>
                                <span className="mt-6 text-xs uppercase tracking-wider text-zinc-300 group-hover:text-volt inline-flex items-center gap-2">
                                    {t.news.read_more} <ArrowUpRight size={14} />
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>

                <div className="mt-10">
                    <Link
                        to="/news"
                        data-testid="news-view-all"
                        className="btn-ghost inline-flex items-center gap-2 px-6 py-3 text-xs uppercase font-bold tracking-wider"
                    >
                        {t.news.view_all} →
                    </Link>
                </div>
            </div>
        </section>
    );
}
